import { render, staticRenderFns } from "./StyleDialogLabelsTab.vue?vue&type=template&id=1907cba8&scoped=true&"
import script from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
export * from "./StyleDialogLabelsTab.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogLabelsTab.vue?vue&type=style&index=0&id=1907cba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907cba8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VContainer,VForm,VTooltip})
